import React from 'react';

const AuthorList = ({ authors }) => {
  if (!Array.isArray(authors) || authors.length === 0) {
    return (
      <div className="empty-state">
        <p>✍️ Авторов пока нет</p>
        <p className="empty-hint">Нажмите "Добавить автора" чтобы добавить первого автора</p>
      </div>
    );
  }

  return (
    <div className="authors-grid">
      {authors.map(author => (
        <div key={author.id} className="author-card">
          {author.photo && (
            <img src={author.photo} alt={author.full_name} className="author-photo" />
          )}
          <div className="author-info">
            <h4>{author.full_name || `${author.last_name} ${author.first_name}`}</h4>
            <p className="author-country">{author.country}</p>
            {author.bio && <p className="author-bio">{author.bio.substring(0, 100)}...</p>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AuthorList;
